import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import {
  productDeleteRequest,
  productViewAllRequest,
} from "../../../redux/products/ProductAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import { styles } from "../../components/formStyles";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
  paginationStyles,
} from "../../components/style";
import CustomDataGrid from "../../constant/commondatagrid";
import { getData } from "./Data";
import { filterStyles } from "../../components/LoginStyles";

const columns = (handleDeleteRow) => [
  {
    field: "id",
    headerName: "Transaction Id",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "No Transaction ID",
  },
  {
    field: "customer_name",
    headerName: "Customer Name",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "No Customer Name",
  },
  {
    field: "bar_name",
    headerName: "Bar Name",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "No Bar Name",
  },
  {
    field: "mobile",
    headerName: "Mobile No",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "No Mobile No",
  },
  {
    field: "email_id",
    headerName: "Email",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "No Email",
  },
  {
    field: "no_of_shots",
    headerName: "No Of Shots",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "0",
  },
  {
    field: "no_of_quantity",
    headerName: "No Of Quantity",
    width: getColumnWidth("column3"),
    renderCell: (params) => params.value || "0",
  },
  {
    field: "total_amount",
    headerName: "Total Amount",
    width: getColumnWidth("column3"),
    renderCell: (params) => {
      const formattedPrice = params.value
        ? `$${parseFloat(params.value).toFixed(2)}`
        : "$0.00";
      return formattedPrice;
    },
  },
  {
    field: "payment_status",
    headerName: "Payment Status",
    width: getColumnWidth("column3"),
    renderCell: (params) => {
      return params?.value === "paid" ? (
        <ActiveValue>Paid</ActiveValue>
      ) : (
        <InactiveValue>UnPaid</InactiveValue>
      );
    },
  },
];

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/wholesaler/product/edit/${user?.id}`);
  };

  const handleView = () => {
    navigate(`/wholesaler/product/detail/${user?.id}`, {});
    handleClose();
  };

  const handleDelete = () => {
    onDelete(user?.id);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleView} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const TransactionList = () => {
  const [rows, setRows] = useState(getData());
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const productViewAllState = useSelector(
    (state) => state?.product?.viewAllProducts || {}
  );
  const productList = productViewAllState?.data?.data || [];
  const totalRecords = productViewAllState?.data?.totalRecords || 0;
  const productPageSize = 10;

  const handleDeleteRow = (id) => {
    setProductToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(productDeleteRequest(productToDelete));
    setRows((prevRows) => prevRows.filter((row) => row.id !== productToDelete));
    setProductToDelete(null);

    dispatch(productViewAllRequest(currentPage));
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Bar Name Asc":
        sortedRows.sort((a, b) => a?.bar_name?.localeCompare(b?.bar_name));
        break;
      case "Sort by Bar Name Desc":
        sortedRows.sort((a, b) => b?.bar_name?.localeCompare(a?.bar_name));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={7} md={7} lg={8} xl={9}>
          <Box className="headingTable">
            <h1>Financial Transactions</h1>
            <p>Here is your general transactions list data</p>
          </Box>
        </Grid>

        <Grid item xs={12} sm={5} md={5} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Asc")}
          >
            Bar Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Desc")}
          >
            Bar Name Z-A
          </MenuItem>
        </Menu>
        <Paper>
          <Box>
            {productViewAllState?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={productViewAllState?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            )}
            {productViewAllState?.inProgress ? (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={productViewAllState?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            ) : (
              <CustomDataGrid
                rows={rows}
                columns={columns(handleDeleteRow)}
                pageSize={productPageSize}
                pagination={true}
                rowHeight={70}
                onSelectionModelChange={(newSelection) => {
                  setSelection(newSelection);
                }}
                sx={filterStyles.modalHeight(rows)}
              />
            )}
            {selection.length > 0 && (
              <div>
                <h2>Selected Rows:</h2>
                {selection.map((id) => (
                  <div key={id}>
                    {rows.find((row) => row.id === id).CustomerName}
                  </div>
                ))}
              </div>
            )}
          </Box>
        </Paper>
        <Box mt={2}>
          <Grid>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <Typography
                variant="body1"
                component="p"
                textAlign={"start"}
                marginTop={6}
                marginBottom={5}
              >
                Showing {productPageSize} from {totalRecords} data
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Box
                className="button-box"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  sx={paginationStyles.PreviousButton}
                  startIcon={
                    <KeyboardDoubleArrowLeftIcon sx={{ fontSize: "10px" }} />
                  }
                >
                  Previous
                </Button>

                <Box
                  sx={{
                    backgroundColor: "#e3e4eb",
                    display: "flex",
                    alignItems: "center",
                    marginX: 1,
                  }}
                >
                  {Array.from(
                    {
                      length: Math.min(
                        Math.ceil(totalRecords / productPageSize),
                        3
                      ),
                    },
                    (_, i) => i + 1
                  ).map((pageNumber) => (
                    <Button
                      key={pageNumber}
                      onClick={() => setCurrentPage(pageNumber)}
                      sx={{
                        backgroundColor:
                          currentPage === pageNumber ? "#fff" : "#e3e4eb",
                        color: currentPage === pageNumber ? "#000" : "#b6bee8",
                        ...paginationStyles.arrayButtons,
                      }}
                    >
                      {pageNumber}
                    </Button>
                  ))}
                </Box>
                <Button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(
                        prev + 1,
                        Math.ceil(totalRecords / productPageSize)
                      )
                    )
                  }
                  sx={{
                    ...paginationStyles.nextButton,
                  }}
                  endIcon={
                    <KeyboardDoubleArrowRightIcon sx={{ fontSize: "10px" }} />
                  }
                >
                  Next
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this row?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              sx={{
                backgroundColor: "rgb(189, 189, 191)",
                color: "rgb(252, 249, 249)",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              sx={{ backgroundColor: "rgb(0,55,255)", color: "#fff" }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </StyledContainer>
    </>
  );
};

export default TransactionList;
